import React, {useEffect, useRef, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import auth from "../../../utils/authentication";
import ImageProfile from "../imageProfile/imageProfile";
import {ConfirmationModal, TitlePage} from "../../shared";
import InputSaveEdit from "../../shared/inputSaveEdit";
import users from "../../users";
import {useDispatch, useSelector} from "react-redux";
import functions from "../../../utils/functionsFirebase";
import ChangePassword from "../changePassword";
import {toast} from "react-toastify";
import firebase from "../../../utils/firebase";
import app from "../../app";
import avatarDefault from "../../../images/avatardefault.png";
import VerificationStatus from "../../app/verificationStatus";
import {cn, getCachedImageUrl, uploadFile} from "../../../utils/utils";
import {updateProfile} from "firebase/auth";

import '../../app/myProfileView/myProfileView.scss';
import './myProfile.scss';
import ChangeBackgroundModal from "./changeBackgroundModal/changeBackgroundModal";
import useUserPreferences from "../../user-app-config/hooks/use-user-preferences";
import ButtonV2 from "../../shared/button-v2/button-v2";
import UserAppConfig from "../../user-app-config/user-app-config";

function MyProfile() {
    const intl = useIntl();
    const user = auth.currentUser;
    const dispatch = useDispatch();
    const buttonOpenSecondDelete = useRef(null);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [confirmDelete2, setConfirmDelete2] = useState(false);
    const [loadingDeleteModal, setLoadingDeleteModal] = useState(false);
    const buttonToggleModal = useRef(null);
    const loading = useSelector(users.selectors.isLoading)
    const [customClaims, setCustomClaims] = useState(null);
    const [displayName, setDisplayName] = useState(user.displayName);
    const darkMode = useSelector(users.selectors.isDarkMode);
    const [changeBackgroundOpen, setChangeBackgroundOpen] = useState(false);
    const {userPreferences} = useUserPreferences();

    const userConfig = useSelector(users.selectors.getUserConfiguration);

    useEffect(() => {
        auth.currentUser.getIdTokenResult().then((idTokenResult) => {
            setCustomClaims(idTokenResult.claims);
        });

    }, [loading]);

    const onSaveUserName = newUsername => {
        if (newUsername === user.displayName) {
            return;
        }
        setDisplayName(newUsername);

        dispatch(users.actions.loading());
        const updateUserCode = functions.httpsCallable('updateUserCode');
        updateUserCode({userName: newUsername, userId: user.uid}).then(
            res => {
                if (res.data?.error) {
                    user.getIdTokenResult(true).then(user => {
                        dispatch(users.actions.loaded());
                        setDisplayName(auth.currentUser.displayName);
                        toast.error(intl.formatMessage({id: "profile.change-username.error"}));
                    }).catch((error) => {
                        console.log(error);
                    });
                } else {
                    user.updateProfile({displayName: newUsername}).then(() => {
                        user.getIdTokenResult(true).then(() => {
                            dispatch(users.actions.loaded());
                            toast.success(intl.formatMessage({id: "profile.change-username.success"}));
                        }).catch((error) => {
                            console.log(error);
                        });
                    });
                }
            });
    }

    const onCloseChangePassword = (result) => {
        if (result) {
            //password has changed
        }
    }

    async function handleFirstConfirmation(result, password) {
        if (result) {
            setLoadingDeleteModal(true);
            if (user.providerData[0].providerId === 'password' && password) {
                const credential = firebase.auth.EmailAuthProvider.credential(
                    user.email,
                    password
                );

                await user.reauthenticateWithCredential(credential).then(r => user.updatePassword(password).then(
                    () => {
                        setConfirmDelete(false);
                        setLoadingDeleteModal(false);
                        setConfirmDelete2(true);
                        buttonOpenSecondDelete.current.click();
                    }
                )).catch(
                    () => {
                        setConfirmDelete(false);
                        setLoadingDeleteModal(false);
                        toast.error(intl.formatMessage({id: 'profile.user-delete.incorrect-password'}));
                    }
                )
            } else if (user.providerData[0].providerId === 'google.com') {
                const provider = new firebase.auth.GoogleAuthProvider();

                await user.reauthenticateWithPopup(provider).then(res => {
                    setConfirmDelete(false);
                    setLoadingDeleteModal(false);
                    setConfirmDelete2(true);
                    buttonOpenSecondDelete.current.click();
                }).catch(error => {
                    setConfirmDelete(false);
                    setLoadingDeleteModal(false);
                    toast.error(intl.formatMessage({id: 'profile.user-delete.incorrect-account'}))
                });

            } else {
                setConfirmDelete(false);
                setLoadingDeleteModal(false);
            }
        } else {
            setConfirmDelete(false);
            setLoadingDeleteModal(false);
        }
    }

    async function handleSecondConfirmation(result) {
        setConfirmDelete2(false);
        if (result) {
            setLoadingDeleteModal(true);
            dispatch(app.actions.loading);
            const deleteAccount = functions.httpsCallable('deleteAccount');
            await deleteAccount({userId: user.uid}).then(
                async res => {
                    if (res.data.deleted) {
                        await auth.currentUser.reload().then().catch(() => {
                        });
                        toast.success(intl.formatMessage({id: 'profile.user-delete.successfully-deleted'}));
                        dispatch(app.actions.loaded);
                        setLoadingDeleteModal(false);
                        window.location.reload();
                    } else {
                        dispatch(app.actions.loaded);
                        toast.error(intl.formatMessage({id: 'profile.user-delete.error-deleting'}));
                        setLoadingDeleteModal(false);
                    }
                });
        }
    }

    const handleProfilePictureUpload = async (file) => {
        dispatch(users.actions.loading());
        let returnUrl = await uploadFile(file, `profilePictures/${auth.currentUser.uid}`);
        if (returnUrl) {
            // Update the user's profile with the new profile picture URL
            await updateProfile(auth.currentUser, {
                photoURL: returnUrl,
            });
            toast.success(intl.formatMessage({id: "profile.change-photo.success"}));
            dispatch(users.actions.loaded());
            return returnUrl;
        } else {
            return '';
        }
    };

    function logOut() {
        auth.signOut().then(() =>
            window.location.reload());
    }

    return (
        <div className={cn(darkMode ? "my-profile-form my-profile-form--dark" : "my-profile-form",)}>
            <button style={{display: 'none'}} ref={buttonToggleModal}
                    data-bs-toggle="modal" data-bs-target="#changePasswordModal"/>
            <ChangePassword onClose={onCloseChangePassword}/>
            <ChangeBackgroundModal open={changeBackgroundOpen} onClose={() => setChangeBackgroundOpen(false)}/>
            <div className="d-flex justify-content-center flex-wrap">
                <div className="col-12 d-flex justify-content-center align-items-center">
                    <ButtonV2 onClick={() => setChangeBackgroundOpen(true)}>
                        Cambiar Fondo &nbsp;<i className="fa-solid fa-image"></i>
                    </ButtonV2>
                </div>
                <div className="my-profile-form__image-profile-container">
                    <ImageProfile image={user.photoURL ? getCachedImageUrl(user.photoURL) : avatarDefault}
                                  handleProfilePictureUpload={handleProfilePictureUpload}/>
                </div>
                <div className="col-md-6 d-flex justify-content-center align-items-center mt-3">
                    <InputSaveEdit inputValue={displayName} onSave={e => onSaveUserName(e)}
                                   label={intl.formatMessage({id: "users.input.user"})}/>
                </div>
                <div className="col-12 d-flex flex-row flex-wrap">
                    {!user.emailVerified && <VerificationStatus className={"col-12 mt-3"}/>}
                    {user.providerData[0].providerId === "password" &&
                        <div className="col-12 d-flex flex-wrap justify-content-center mt-3">
                            <button className="btn btn-outline-secondary col-12"
                                    onClick={() => buttonToggleModal.current.click()}>
                                <FormattedMessage id="profile.change-password"/> &nbsp;
                                <i className="fa-solid fa-key"></i>
                            </button>
                        </div>
                    }
                </div>

                <div className="col-12 mt-4">
                    <UserAppConfig/>
                </div>

                <div className="col-12 pb-3">
                    <div className="mb-2"/>
                    <TitlePage icon="fa-solid fa-user" title={"Detalle de la cuenta"}
                               leftClass="col-12"/>
                    <div className="mb-4">
                        <div>
                            <strong>Email:</strong>
                        </div>
                        <div className="ps-3">
                            <span> {user.email}</span>
                        </div>
                    </div>
                    <button style={{display: "none"}} id={"deleteAccountBtn"} data-bs-toggle="modal"
                            data-bs-target="#confirmDeleteFirst">
                    </button>
                    <div className="d-flex flex-wrap gap-3">
                        <ButtonV2
                            variant="danger"
                            size="small"
                            onClick={() => {
                                setConfirmDelete(true);
                                document.getElementById('deleteAccountBtn').click();
                            }}>
                            <FormattedMessage id="profile.user-suppress.delete"/>
                        </ButtonV2>
                        <ButtonV2 onClick={logOut} variant="primary" size="small">
                            <FormattedMessage
                                id="users.log-out"/> &nbsp;
                            <i className="fa-solid fa-right-from-bracket"/>
                        </ButtonV2>
                    </div>
                    <button hidden={true} data-bs-toggle="modal" data-bs-target="#confirmDeleteSecond"
                            ref={buttonOpenSecondDelete}>
                    </button>
                </div>
                {user.providerData[0].providerId === "google.com" &&
                    <ConfirmationModal open={confirmDelete} onClose={handleFirstConfirmation}
                                       title={intl.formatMessage({id: "profile.user-delete.warning.title"})}
                                       message={intl.formatMessage({id: "profile.user-delete.warning.message-google"})}
                                       confirmText={intl.formatMessage({id: "profile.user-delete.warning.button"})}
                                       btnClass="btn-danger" modalName="confirmDeleteFirst"
                                       loading={loadingDeleteModal}/>
                }
                {user.providerData[0].providerId === "password" &&
                    <ConfirmationModal open={confirmDelete} onClose={handleFirstConfirmation}
                                       title={intl.formatMessage({id: "profile.user-delete.warning.title"})}
                                       message={intl.formatMessage({id: "profile.user-delete.warning.message"})}
                                       confirmText={intl.formatMessage({id: "profile.user-delete.warning.button"})}
                                       askInput={intl.formatMessage({id: "users.input.password"})}
                                       inputType="password" modalName="confirmDeleteFirst"
                                       btnClass="btn-danger" loading={loadingDeleteModal}/>
                }
                <ConfirmationModal open={confirmDelete2} onClose={handleSecondConfirmation}
                                   title={intl.formatMessage({id: "profile.user-delete.warning.title"})}
                                   message={intl.formatMessage({id: "profile.user-delete.confirm.message"})}
                                   confirmText={intl.formatMessage({id: "profile.user-delete.confirm.button"})}
                                   warningLevel='danger' modalName="confirmDeleteSecond"
                                   btnClass="btn-danger" loading={loadingDeleteModal}/>

            </div>
        </div>)

}

export default MyProfile;
